import React, { useState } from 'react';
import Navigation from './Navigation';
import './CaseStudyTemplate.css';

const CaseStudyTemplate = ({
  clientName,
  title,
  subtitle,
  heroImage,
  heroImageAlt,
  galleryImages = [],
  summary,
  challenge,
  roleAndApproach,
  outcomes,
  keyDeliverables,
  quotes,
  lessonsLearned
}) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openImageModal = (imageSrc, imageAlt) => {
    setSelectedImage({ src: imageSrc, alt: imageAlt });
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };
  return (
    <div className="case-study-page">
      <Navigation />

      {/* Hero Section */}
      <div className="case-study-hero-timeline">
        <div className="hero-content">
          {clientName && <div className="client-tag">{clientName}</div>}
          <h1>{title}</h1>
          <p className="hero-subtitle">{subtitle}</p>
        </div>
      </div>

      {/* Timeline Content */}
      <div className="timeline-container">
        <div className="timeline-item">
          <div className="timeline-marker timeline-marker-star">★</div>
          <div className="timeline-content-block">
            <h3>Summary</h3>
            <div className="content-area">
              {summary}
            </div>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-marker">1</div>
          <div className="timeline-content-block">
            <h3>The Challenge</h3>
            <div className="content-area">
              {challenge}
            </div>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-marker">2</div>
          <div className="timeline-content-block">
            <h3>Approach</h3>
            <div className="content-area">
              {roleAndApproach}
            </div>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-marker">3</div>
          <div className="timeline-content-block">
            <h3>Outcomes</h3>
            <div className="content-area">
              {outcomes}
            </div>
          </div>
        </div>

        <div className="timeline-item">
          <div className="timeline-marker">4</div>
          <div className="timeline-content-block">
            <h3>Key Deliverables</h3>
            <div className="content-area">
              {keyDeliverables}
            </div>
          </div>
        </div>

      </div>

      {/* Image Gallery */}
      <div className="image-gallery-section">
        <div className="image-gallery">
          <div className="image-scroll-container">
            {galleryImages && galleryImages.length > 0 ? (
              galleryImages.map((image, index) => (
                <div key={image.id || index} className="image-item" onClick={() => openImageModal(image.url, image.filename || `Gallery image ${index + 1}`)}>
                  <img src={image.url} alt={image.filename || `Gallery image ${index + 1}`} />
                </div>
              ))
            ) : heroImage ? (
              <div className="image-item" onClick={() => openImageModal(heroImage, heroImageAlt)}>
                <img src={heroImage} alt={heroImageAlt} />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      {/* Quotes Section - Outside Timeline */}
      {quotes && (
        <div className="quotes-section">
          <div className="quotes-container">
            <h2>Client Feedback</h2>
            <div className="quotes-content">
              {quotes}
            </div>
          </div>
        </div>
      )}

      {/* Lessons Learned Section - Outside Timeline */}
      <div className="lessons-learned-section">
        <div className="lessons-learned-container">
          <h2>Lessons Learned</h2>
          <div className="lessons-content">
            {lessonsLearned}
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="image-modal" onClick={closeImageModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="image-modal-close" onClick={closeImageModal}>×</button>
            <img src={selectedImage.src} alt={selectedImage.alt} />
          </div>
        </div>
      )}
    </div>
  );
};

export default CaseStudyTemplate;